import { api } from "../utils/api";
import type { RestBundle } from "@KassaroAB/shared/types/bundle";

export const REFERENCE_BRAND = "Kassaro";

export type Version = {
  id: string;
  version: string;
};

export type Brand = {
  id: string;
  name: string;
  activeBundleId?: string;
  activeBundleIdAdmin?: string;
};

export type ActivateBundleForAllBrandsResult = {
  activatedBrandIds: string[];
  skippedBrands: { brandId: string; brandName: string }[];
};

export const getVersionsApi = async (cursor: string | null, limit: number = 10): Promise<Version[]> => {
  const params = new URLSearchParams();
  if (cursor) {
    params.set("cursor", cursor);
  }
  params.set("limit", limit.toString());
  return api.get(`admin/versions?${params.toString()}`);
};

export const getBrandsForVersionApi = async (versionId: string): Promise<Brand[]> => {
  return api.get(`admin/versions/${versionId}/brands`);
};

export const getBundlesForBrandVersionApi = async (
  versionId: string,
  brandId: string,
  cursor: string | null = null,
  limit: number = 10,
): Promise<RestBundle[]> => {
  const params = new URLSearchParams();
  if (cursor) {
    params.set("cursor", cursor);
  }
  params.set("limit", limit.toString());
  return api.get(`admin/versions/${versionId}/brands/${brandId}/bundles?${params.toString()}`);
};

export const activateBundleForAllBrandsApi = async (
  versionId: string,
  bundleId: string,
): Promise<ActivateBundleForAllBrandsResult> => {
  return api.post(`admin/versions/${versionId}/bundles/${bundleId}/activate-all`, {});
};

export const activateBundleForAdminsAllBrandsApi = async (
  versionId: string,
  bundleId: string,
): Promise<ActivateBundleForAllBrandsResult> => {
  return api.post(`admin/versions/${versionId}/bundles/${bundleId}/activate-admins`, {});
};

export const updateBrandConfigApi = async (
  versionId: string,
  brandId: string,
  data: { activeBundleId?: string; activeBundleIdAdmin?: string },
): Promise<void> => {
  return api.put(`admin/versions/${versionId}/brands/${brandId}/config`, data);
};
